export class empresa {
	rut: number;
	nombre: string;
	activo: boolean;
	es_holding: boolean;
	fecha_creacion: Date;
    latitud: string;
    longitud: string;
}